import { useTranslation } from 'react-i18next';
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Text,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@shared/ui';

export function TooltipShowcase() {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.overlay.tooltip.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.overlay.tooltip.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button variant="outline">{t('uiLibrary.overlay.tooltip.trigger')}</Button>
            </TooltipTrigger>
            <TooltipContent>
              <Text size="sm">{t('uiLibrary.overlay.tooltip.content')}</Text>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </CardContent>
    </Card>
  );
}
